import React, { Fragment } from 'react'
import { Route, Switch } from 'react-router-dom'
import Authorized from '-/utils/Authorized'
import history from '-/utils/history'
import { getRouterData } from './routerData'
import UpdateUserInfo from '-/components/business/UpdateUserInfo'

const { AuthorizedRoute } = Authorized

const redirect = {
  pathname: '/user/login',
  state: {
    from: history.location.pathname,
  },
}

const Routes = (): JSX.Element => {
  const routerData = getRouterData()
  const UserLayout = routerData['/user'].component
  const BasicLayout = routerData['/'].component

  return (
    <Fragment>
      <Switch>
        <Route path="/user" component={UserLayout} />
        <UpdateUserInfo>
          <AuthorizedRoute
            path="/"
            render={innerProps => <BasicLayout {...innerProps} />}
            // TODO: 提取成一个变量维护和 UserAuthority 统一
            authority={[
              'userManage',
              'prescriptionManage',
              'channelManage',
              'freightManage',
              'drugManage',
              'afterSaleManage',
              'openStore',
            ]}
            redirectTo={redirect}
          />
        </UpdateUserInfo>
      </Switch>
    </Fragment>
  )
}

export default Routes
